export const useWithSharedEvent =
  typeof window !== "undefined" && !!window.useWithSharedEvent
    ? window.useWithSharedEvent
    : func => func;
export const onSharedEvent =
  typeof window !== "undefined" && !!window.onSharedEvent
    ? window.onSharedEvent
    : () => {};
